import type React from "react";
import { DocumentSubType } from "@/briefpoint-client";
import { Modal } from "@/components/Modals";
import { CaliforniaId } from "@/lib/constants";
import type { JurisdictionResponse } from "@/lib/types";
import { getSubTypeText } from "@/lib/utils";
import ExternalPartnerActions from "../ExternalPartnerActions/ExternalPartnerActions";
import styles from "./RespondToDiscoveryModal.module.scss";

interface RespondToDiscoveryModalProps {
  isShow: boolean;
  quickActionIsSaving: boolean;
  getFirmJx: JurisdictionResponse | undefined;
  handleQuickActionExternalUpload?: () => void;
  setShowUploadDocs: React.Dispatch<React.SetStateAction<boolean>>;
  handleChooseFile: (e: React.MouseEvent) => void;
  onClose: () => void;
  onConfirm: (value: DocumentSubType) => void;
}

export default function RespondToDiscoveryModal(
  props: RespondToDiscoveryModalProps,
) {
  function onSubmit() {
    // This modal only shows document types, so we can call onConfirm with a default type
    // or let the parent handle the type selection
    props.onConfirm(DocumentSubType.RequestsForAdmission);
  }

  return (
    <Modal
      show={props.isShow}
      onClose={props.onClose}
      onSecondaryAction={props.handleQuickActionExternalUpload}
      onConfirm={onSubmit}
      showConfirmButton={false}
      disableConfirmButton={props.quickActionIsSaving}
      showCancelButton={false}
      cancelText="Cancel"
      confirmText="Upload Document"
      size="lg"
      title="Respond to Discovery"
    >
      <div className={styles.quickActionContainer}>
        <p>
          To draft a response to a discovery request, please upload a .pdf of
          one of the following:
        </p>
        <ul>
          <li>
            {
              getSubTypeText(
                DocumentSubType.RequestsForAdmission,
                props.getFirmJx?.id ?? "",
              ).plural
            }
          </li>
          <li>
            {
              getSubTypeText(
                DocumentSubType.RequestsForProduction,
                props.getFirmJx?.id ?? "",
              ).plural
            }
          </li>
          <li>
            {
              getSubTypeText(
                DocumentSubType.SpecialInterrogatories,
                props.getFirmJx?.id ?? "",
              ).plural
            }
          </li>
          {props.getFirmJx?.id === CaliforniaId && (
            <li>
              {
                getSubTypeText(
                  DocumentSubType.FormInterrogatories,
                  props.getFirmJx?.id ?? "",
                ).plural
              }
            </li>
          )}
        </ul>
        <div className={styles.quickAccBtnContainer}>
          <ExternalPartnerActions
            toggleOnly={false}
            handleQuickActionExternalUpload={
              props.handleQuickActionExternalUpload ?? (() => {})
            }
            setShowUploadDocs={props.setShowUploadDocs}
            handleChooseFile={props.handleChooseFile}
          />
        </div>
      </div>
    </Modal>
  );
}
